import React from 'react'
import ProjectsComponent from '../components/Projects/project'

const Projects = () => {
  return (
    <ProjectsComponent />
  )
}

export default Projects
